export default [
    {
        path: `/followups/search`,
        component: () => import('@/pages/followups/index.vue')
    }
]
